require('../../../../shared/clipSearch/clipFilterService');

angular.module('app.admin.videoAnalysis.tabs.filterForm.filterFormController', [
  'app.shared.clipSearch.clipFilterService'
])
  .controller('app.admin.videoAnalysis.tabs.filterForm.filterFormController', [
    '$scope',
    '$stateParams',
    '$sce',
    '$state',
    'app.shared.clipSearch.clipFilterService',
    '$rootScope',
    function ($scope, $stateParams, $sce, $state, clipFilterService, $rootScope) {
      "use strict";

      $scope.filterFormData = {
        filters: {},
        labels: {},
        preset: null
      };

      $scope.showPresetActions = false;

      $scope.canUpdatePresets = false;

      $scope.filterTemplate = {
        buttonTemplate: 'admin.videoAnalysis.filterForm.filterButtons.html',
        buttonClass: 'clip-actions__buttons--row-layout-multiple',
        submit: () => {
          $state.go('app.admin.videoAnalysis.myClips', {
            filter: JSON.stringify($scope.filterFormData.filters),
            preset: JSON.stringify($scope.filterFormData.preset), submitted: true
          });
        },

        cancel: () => {
          $scope.filterFormData.filters = {};
          $scope.filterFormData.labels = {};

          $scope.$broadcast('clear_dates');
          $scope.$broadcast('clear_selected_preset');

          if (angular.isObject($scope.filterFormData.preset)) {
            $scope.filterFormData.preset = null;
          }
        },

        showPresets: () => {
          $scope.showPresetActions = true;
        },

        updatePreset: () => {
          $rootScope.$broadcast('update_preset');
        },

        deletePreset: () => {
          $rootScope.$broadcast('delete_preset');
        }
      };

      $scope.emptyFilterTemplate = {
        message: $sce.trustAsHtml('Use the filters below to filter category, opponent, date range, and/or player'),
        buttonTemplate: 'admin.videoAnalysis.filterForm.emptyFilterButtons.html',
        buttonClass: 'clip-actions__buttons--row-layout',
        goToPrevTab: () => {
          $state.go('app.admin.videoAnalysis.myClips', {
            filter: JSON.stringify($scope.filterFormData.filters),
            preset: JSON.stringify($scope.filterFormData.preset),
            submitted: false
          });
        }

      };

      let init = () => {
        buildLabels();
      };

      let buildLabels = () => {
        $scope.filterFormData.filters = angular.isDefined($scope.cachedFilterData.filters) ? JSON.parse($scope.cachedFilterData.filters) : {};

        $scope.filterFormData.preset = angular.isDefined($scope.cachedFilterData.preset) ? JSON.parse($scope.cachedFilterData.preset) : null;
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/tabs/filterForm/filterFormController.js